<template>
    <vx-card class="overflow-hidden">
        <div slot="no-body">
            <div class="p-6 flex flex-column justify-center items-center text-center">
                <hexasense-icon :w="42" :h="42" :classes="`text-${color}`" :icon="icon" class="p-2 inline-flex rounded-full mb-4" :style="{background: `rgba(var(--vs-${color}),.15)`}" />
                <div class="truncate">
                    <h2 class="mb-1 font-bold text-3xl" >{{ statistic }}</h2>
                    <span class="text-xl">{{ statisticTitle }}</span>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import HexasenseIcon from '../../../libs/icons/index.vue'
export default{
  components:{
    HexasenseIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    statistic: {
      type: [Number, String],
      required: true
    },
    statisticTitle: {
      type: String
    },
    color: {
      type: String,
      default: 'primary'
    }
  }
}
</script>
